export default function initializeGalleryGrid() {
    new GalleryGrid();
}

class GalleryGrid {
    constructor() {
        this.init();
    }

    init() {
        const galleryButtons = document.querySelectorAll('.block-gallery-grid__button span');

        galleryButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                const blockId = this.getAttribute('data_id');
                const galleryData = document.querySelector(`#block-${blockId} .block-gallery-grid__data`);

                if (this.classList.contains('block-gallery-grid__gallery__down')) {
                    this.classList.remove('d-block');
                    this.classList.add('d-none');
                    this.nextElementSibling.classList.remove('d-none');
                    this.nextElementSibling.classList.add('d-block');
                    galleryData.classList.toggle('block-gallery-grid__more');
                } else if (this.classList.contains('block-gallery-grid__gallery__up')) {
                    this.classList.remove('d-block');
                    this.classList.add('d-none');
                    this.previousElementSibling.classList.remove('d-none');
                    this.previousElementSibling.classList.add('d-block');
                    galleryData.classList.toggle('block-gallery-grid__more');
                }
            });
        });
    }
}
